import type { Experiment, Result } from '@growthbook/growthbook-react';
import { ADD_GROWTHBOOK_EXPERIMENT } from '../../constants/growthbookExperiments';
import type { RootState } from '../../store';

export interface GrowthbookExperiment {
  experiment: Experiment<any>;
  result: Result<any>;
}

export const initialState: GrowthbookExperiment[] = [];

const growthbookExperiments = (
  state = initialState,
  { type, payload }: { type: string; payload: GrowthbookExperiment }
): GrowthbookExperiment[] => {
  if (type === ADD_GROWTHBOOK_EXPERIMENT) {
    return [...state, payload];
  }

  return state;
};

export default growthbookExperiments;

export const growthbookExperimentsSelector = (state: RootState) =>
  state?.app?.growthbookExperiments ?? initialState;
